import React, { useEffect, useState } from "react";
import { Button, Row } from "react-bootstrap";
import "../../../assets/scss/utilities/_calendar.scss";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import Label from "../../../components/UI/Label/Label";
import CartaoMes from "./components/CartaoMes";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";

const ExpedienteAtipico = ({ history, match }) => {
  const { request: requestPontoFacultativo, data: dataPontoFacultativo, errors, isLoading } = useApiClient();
  const [anoAtual, setAnoAtual] = useState(0);
  const [dataSelecionada, setDataSelecionada] = useState([]);
  const [facultativos, setFacultativos] = useState([]);
  const [feriados, setFeriados] = useState([]);
  const [listaAtualizada, setListaAtualizada] = useState(false);

  const handleNextYear = () => {
    setAnoAtual(anoAtual + 1);
    setListaAtualizada(false);
  };

  const handlePrevYear = () => {
    setAnoAtual(anoAtual - 1);
    setListaAtualizada(false);
  };

  useEffect(() => {
    if (!anoAtual) {
      setAnoAtual(new Date().getFullYear());
    }
  }, [anoAtual]);

  useEffect(() => {
    if (!listaAtualizada && anoAtual > 0) {
      requestPontoFacultativo(apiRoutes.fiscalizacao.parametrizacao.listaExpedienteAtipico, { ano: anoAtual });
    }
  }, [anoAtual, requestPontoFacultativo, history, listaAtualizada]);

  useEffect(() => {
    setListaAtualizada(history.location?.state?.atualizada);
  }, [history.location?.state?.atualizada]);

  useEffect(() => {
    const listaFacultativos = [];
    const listaFeriados = [];

    if (dataPontoFacultativo?.result) {
      dataPontoFacultativo.result.forEach((item) => {
        if (new Date(item.dataPontoFacultativo).getFullYear() === anoAtual) {
          if (item.fixo === "P") listaFacultativos.push(item);
          else listaFeriados.push(item);
        }
      });

      setFacultativos(listaFacultativos);
      setFeriados(listaFeriados);
      setListaAtualizada(true);
    }
  }, [anoAtual, dataPontoFacultativo, errors]);

  const meses = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return (
    <>
      <Row>
        <h1 className="h3 mb-4 text-gray-800">Expedientes Atípicos</h1>
      </Row>
      <Row>
        <div id="calendario-pagina">
          <div className="cabecalho-pagina">
            <Button id="anoAnterior" onClick={handlePrevYear}>
              <BsArrowLeft />
            </Button>
            <Label className="ano-atual">{anoAtual}</Label>
            <Button id="anoPosterior" onClick={handleNextYear}>
              <BsArrowRight />
            </Button>
          </div>
          {isLoading ? (
            <TextSpinner text="Carregando diretor..." />
          ) : (
            <div className="conteudo">
              {meses.map((valor, indice) => (
                <CartaoMes
                  key={valor}
                  mes={valor}
                  indice={indice}
                  ano={anoAtual}
                  dataSelecionada={dataSelecionada}
                  setDataSelecionada={setDataSelecionada}
                  facultativos={facultativos}
                  feriados={feriados}
                  history={history}
                  match={match}
                />
              ))}
            </div>
          )}
        </div>
      </Row>
    </>
  );
};

export default ExpedienteAtipico;
